import type { ErrorInfo } from 'react';
import type React from 'react';
import { Component } from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface StateProps {
  hasError: boolean;
  error: Error;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, StateProps> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    // @ts-ignore
    this.state = { hasError: false, error: {} };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) return null;

    return children;
  }
}

export default ErrorBoundary;
